// src/components/Sidebar.js
import {
  LayoutDashboard,
  TrendingUp,
  BarChart3,
  Wallet,
  Radio,
  Megaphone,
  History,
  Users,
  Briefcase,
  CheckSquare,
  LifeBuoy,
  Settings,
} from "lucide-react";
import BrandLogo from "./BrandLogo";

const NAV = [
  { id: "dashboard", Icon: LayoutDashboard, label: "Dashboard" },
  { id: "revenue", Icon: TrendingUp, label: "Revenue Ops" },
  { id: "analytics", Icon: BarChart3, label: "Analytics" },
  { id: "finances", Icon: Wallet, label: "Finances" },
  { id: "engagement", Icon: Radio, label: "Engagement" },
  { id: "marketing", Icon: Megaphone, label: "Marketing" },
  { id: "activity", Icon: History, label: "Activity" },
  { id: "contacts", Icon: Users, label: "Contacts", badgeKey: "contacts" },
  { id: "deals", Icon: Briefcase, label: "Deals", badgeKey: "deals" },
  { id: "tasks", Icon: CheckSquare, label: "Task inbox", badgeKey: "tasks" },
  { id: "support", Icon: LifeBuoy, label: "Support" },
];

export default function Sidebar({
  activePage,
  onNavigate,
  contactCount = 0,
  openTaskCount = 0,
  dealCount = 0,
  mobileOpen = false,
  onCloseMobile,
  userEmail = "",
  onSignOut,
}) {
  const badges = { contacts: contactCount, deals: dealCount, tasks: openTaskCount };

  function nav(to) {
    onNavigate(to);
    onCloseMobile?.();
  }

  return (
    <>
      <div
        className={`sidebar-backdrop ${mobileOpen ? "open" : ""}`}
        aria-hidden={!mobileOpen}
        onClick={onCloseMobile}
      />
      <aside className={`sidebar ${mobileOpen ? "sidebar--open" : ""}`}>
        <div className="sidebar-logo">
          <BrandLogo className="logo-mark" width={40} height={40} />
          <div className="logo-text">
            <div className="name">Scanbrix</div>
            <div className="sub">CRM</div>
          </div>
        </div>

        <div className="sidebar-section">
          <div className="sidebar-label">Workspace</div>
          {NAV.map((item) => {
            const badge = item.badgeKey ? badges[item.badgeKey] : 0;
            const Icon = item.Icon;
            return (
              <div
                key={item.id}
                className={`nav-item ${activePage === item.id ? "active" : ""}`}
                onClick={() => nav(item.id)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && (e.preventDefault(), nav(item.id))}
              >
                <span className="nav-icon">
                  <Icon size={20} strokeWidth={1.75} />
                </span>
                {item.label}
                {badge > 0 && <span className="nav-badge">{badge}</span>}
              </div>
            );
          })}
        </div>

        <div className="sidebar-section">
          <div className="sidebar-label">System</div>
          <div
            className={`nav-item ${activePage === "settings" ? "active" : ""}`}
            onClick={() => nav("settings")}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && (e.preventDefault(), nav("settings"))}
          >
            <span className="nav-icon">
              <Settings size={20} strokeWidth={1.75} />
            </span>
            Settings
          </div>
        </div>

        <div className="sidebar-footer">
          <div className="user-row" style={{ flexDirection: "column", alignItems: "stretch", gap: 8 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <div
                className="avatar"
                style={{ background: "var(--accent-dim)", color: "var(--accent)" }}
              >
                {(userEmail && userEmail.slice(0, 2).toUpperCase()) || "—"}
              </div>
              <div style={{ minWidth: 0 }}>
                <div
                  style={{
                    fontSize: 13,
                    fontWeight: 600,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                  title={userEmail}
                >
                  {userEmail || "Signed in"}
                </div>
                <div className="text-caption">Operator</div>
              </div>
            </div>
            {typeof onSignOut === "function" ? (
              <button type="button" className="btn btn-sm" style={{ width: "100%" }} onClick={onSignOut}>
                Sign out
              </button>
            ) : null}
          </div>
        </div>
      </aside>
    </>
  );
}
